import { useCallback, useState } from 'react';
import { DefaultOrderManager, OrderManager } from 'core/order/OrderManager';
import { Order } from 'core/order/Order';
import { useCallAPI } from 'hooks/useCallAPI';

const orderManager: OrderManager = new DefaultOrderManager();

type OrderDetailData = {
  loading: boolean;
  order: Order | undefined;
  fetchOrder: () => Promise<void>;
};

export const useFetchOrderDetail = (orderNumber: string): OrderDetailData => {
  const [order, setOrder] = useState<Order | undefined>(undefined);
  const { loading, callAPIs } = useCallAPI();

  const fetchOrder = useCallback(() => {
    return callAPIs(
      [() => orderManager.getOrder(orderNumber)],
      (newOrder: Order) => {
        setOrder(newOrder);
      },
    );
  }, [orderNumber, callAPIs]);

  return {
    loading,
    order,
    fetchOrder,
  };
};
